goog.provide("shadow.js.shim.module$react_use$lib$useCopyToClipboard$default");
shadow.js.shim.module$react_use$lib$useCopyToClipboard$default = shadow.js.shim.module$react_use$lib$useCopyToClipboard.default;
